import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import { ScrollToTop } from "../function/Function";

export const MainBg = ({ children }) => {
  return (
    <div className="bg-bodybg ">
      <ScrollToTop />
      <Header />
      {/* min-h-[100vh] */}
      <div className="min:h-screen">{children}</div>
      <Footer />
    </div>
  );
};
